import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function ActivitiesSection() {
  return <section className="w-full py-16 md:py-20" style={{
    backgroundColor: '#f8f6f0'
  }} aria-label="Club activities" data-id="element-1601">
      <div className="max-w-6xl mx-auto px-4 md:px-8" data-id="element-1602">
        <div className="text-center mb-12" data-id="element-1603">
          <p className="text-xs font-bold uppercase tracking-widest mb-2" style={{
          color: '#c8a84b',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1604">
            Programs &amp; Sports
          </p>
          <h2 className="text-3xl md:text-4xl font-bold uppercase" style={{
          fontFamily: 'Oswald, sans-serif',
          color: '#1e3d2f'
        }} data-id="element-1605">
            Club Activities
          </h2>
          <div className="section-divider-center" data-id="element-1606" />
          <p className="text-base max-w-2xl mx-auto" style={{
          color: '#5a5a5a',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1607">
            From competitive shooting sports to archery and education, FLSC
            offers something for every sportsman.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5" data-id="element-1608">
          <a href="/SportingClays.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Sporting Clays" data-id="element-1609">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/Steel%20Challenge%20Generic%2024.jpg" alt="Sporting Clays" className="block absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1610" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-1611" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-1612">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-1613">
                Sporting Clays
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1614">
                16-station course · Public weekends
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1615">
                Learn More <ArrowRightIcon size={12} data-id="element-1616" />
              </span>
            </div>
          </a>

          <a href="/SASS.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Cowboy Action Shooting" data-id="element-1617">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/CASS.jpg" alt="Cowboy Action Shooting" className="block absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1618" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-1619" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-1620">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-1621">
                Cowboy Action
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1622">
                SASS · Period-correct competition
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1623">
                Learn More <ArrowRightIcon size={12} data-id="element-1624" />
              </span>
            </div>
          </a>

          <a href="/JrRifle.htm" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Jr. Rifle" data-id="element-1625">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/JR%20Rifle2.jpg" alt="Jr. Rifle Program" className="block absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1626" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-1627" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-1628">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-1629">
                Jr. Rifle
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1630">
                Ages 10–18 · Tuesday evenings
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1631">
                Learn More <ArrowRightIcon size={12} data-id="element-1632" />
              </span>
            </div>
          </a>

          <a href="/FLSCSelfDefense.html" className="group relative rounded-2xl overflow-hidden block" style={{
          minHeight: '280px',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12)'
        }} aria-label="Education and Training" data-id="element-1633">
            <img src="https://drwzpk38qkpfb.cloudfront.net/www.fentonlakes.com/uploaded/images/Front%20Page/Education-and-Training.gif" alt="Education and Training" className="block absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-1634" />
            <div className="absolute inset-0" style={{
            background: 'linear-gradient(to top, rgba(15,35,24,0.92) 0%, rgba(15,35,24,0.4) 60%, transparent 100%)'
          }} data-id="element-1635" />
            <div className="absolute bottom-0 left-0 right-0 p-5" data-id="element-1636">
              <h3 className="text-xl font-bold uppercase text-white mb-1" style={{
              fontFamily: 'Oswald, sans-serif'
            }} data-id="element-1637">
                Education &amp; Safety
              </h3>
              <p className="text-xs mb-3" style={{
              color: '#a0c8b0',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1638">
                NRA Certified · Members &amp; public
              </p>
              <span className="inline-flex items-center gap-1 text-xs font-semibold" style={{
              color: '#c8a84b',
              fontFamily: 'Inter, sans-serif'
            }} data-id="element-1639">
                Learn More <ArrowRightIcon size={12} data-id="element-1640" />
              </span>
            </div>
          </a>
        </div>

        <div className="mt-8 flex flex-wrap justify-center gap-3" data-id="element-1641">
          {[{
          label: 'Steel Challenge',
          href: '/SteelChallenge.html'
        }, {
          label: '3-D Archery',
          href: '/3DArchery.html'
        }, {
          label: 'PPC Shooting',
          href: '/PPCShooting.html'
        }, {
          label: 'Bowling Pin Shoots',
          href: '/BowlingPinShoots.html'
        }].map(({
          label,
          href
        }) => <a key={href} href={href} className="px-5 py-2.5 rounded-full text-sm font-medium border transition-all hover:bg-forest hover:text-white" style={{
          borderColor: '#2d5a3d',
          color: '#2d5a3d',
          fontFamily: 'Inter, sans-serif'
        }} data-id="element-1642">
              {label}
            </a>)}
        </div>
      </div>
    </section>;
}